import { Stack, Typography } from "@mui/material"
import Logo from "../../assets/riaz_stationery_logo.png";
import MaazLogo from "../../assets/erorex-Logo.png";
import Banner from "../../assets/riaz_stationery_banner.png";

const ClientInfo = () => {
  return (
    <Stack
      sx={{ mb: 2, mt: 1 }}
      direction={"row"}
      justifyContent={"space-between"}
      alignItems={"end"}
      spacing={3}>
      {/* <img src={MaazLogo} alt="logo" width={"250"} height={"70"} /> */}

      <Stack>
        <Stack sx={{ mt: "-20px" }}>
          <Typography sx={{ fontSize: "26px", fontWeight: "bold" }}>
            RZ Traders
          </Typography>
          <Typography sx={{ fontSize: "16px" }}>
            Asad Riaz : 0312-5686984
          </Typography>
          <Typography sx={{ fontSize: "16px" }}>
            M.Mushtaq: 0301-5604119
          </Typography>
        </Stack>
        {/* <img src={Logo} alt="logo" width={"250"} height={"70"} /> */}
      </Stack>
    </Stack>
  )
}

// const ClientInfo = () => {
//     return(
//         <Stack
//         sx={{ mb: 2, mt: 1 }}
//         direction={"row"}
//         justifyContent={"space-between"}
//         alignItems={"end"}
//         spacing={3}>
//         <img src={Banner} alt="logo" width={"100%"} />
//       </Stack>
//     )
// }

export default ClientInfo